/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CoursefinancialBanksBankidPaymentMethods200,
  GetApiV1CoursefinancialBanksBankidPaymentMethods401,
  GetApiV1CoursefinancialBanksBankidPaymentMethods404,
  GetApiV1CoursefinancialBanksBankidPaymentMethods500,
  GetApiV1CoursefinancialBanksBankidPaymentMethodsPathParams,
  GetApiV1CoursefinancialBanksBankidPaymentMethodsQueryResponse,
} from "../../types/courseFinancialSharedController/GetApiV1CoursefinancialBanksBankidPaymentMethods.ts";
import { courseFinancialPaymentMethodOptionViewModelSchema } from "../courseFinancialPaymentMethodOptionViewModelSchema.ts";

export const getApiV1CoursefinancialBanksBankidPaymentMethodsPathParamsSchema =
  z.object({
    bankId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CoursefinancialBanksBankidPaymentMethodsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CoursefinancialBanksBankidPaymentMethods200Schema =
  z.array(
    z.lazy(() => courseFinancialPaymentMethodOptionViewModelSchema),
  ) as unknown as ToZod<GetApiV1CoursefinancialBanksBankidPaymentMethods200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CoursefinancialBanksBankidPaymentMethods401Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialBanksBankidPaymentMethods401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CoursefinancialBanksBankidPaymentMethods404Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialBanksBankidPaymentMethods404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CoursefinancialBanksBankidPaymentMethods500Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialBanksBankidPaymentMethods500>;

export const getApiV1CoursefinancialBanksBankidPaymentMethodsQueryResponseSchema =
  z.lazy(
    () => getApiV1CoursefinancialBanksBankidPaymentMethods200Schema,
  ) as unknown as ToZod<GetApiV1CoursefinancialBanksBankidPaymentMethodsQueryResponse>;
